import type { Theme } from '@/types';

export const getTheme = (theme: Theme) => (theme === 'light' ? 'secondary' : 'primary');
